import { formatNumber } from "Helpers/numbers";

export const formatSeconds = (val: unknown, currency?: string, options?: { isKM?: boolean }) =>
  `${formatNumber(Number(val))}s`;
